<template>
    <div class="display3d">
        <div id="map" style="background-color: black"/>
        <div @click="$router.back()" id="backBtn">退出3D浏览</div>
    </div>
</template>

<script>

import mapboxgl from "mapbox-gl";

export default {
    name: "ThreeDimensionalLayer",
    mounted() {
    if (this.$route.query.layer != null) {
      this.layer = this.$route.query.layer
      this.bounds = this.$route.query.bounds
    }
    let temp = setInterval(()=>{
      if(this.$store.state.mapboxTokenIndex){
        this.init();
        clearInterval(temp)
      }
    })
  },
  data() {
        return {
          layer:'',
          bounds:'',
          animationId:-1,
          frameCount: 0,
          animation: false,
          pause: false,
          // savedTimestamp: 0,
          timedOut: -1,
        }
    },
    methods: {
        init() {
            mapboxgl.accessToken = this.$utils.mapboxToken;
            this.map = new mapboxgl.Map({
                container: 'map',
                style: {
                  name: 'blank',
                  version: 8,
                  sources: {},
                  layers: []
                },
                maxZoom: 17,
            });
            this.map.on('load', () => {
                this.map.addSource('mapbox-dem', {
                    type: 'raster-dem',
                    url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                    tileSize: 512,
                    maxZoom: 14,
                });
                this.map.setTerrain({'source': 'mapbox-dem', 'exaggeration': 1});
                this.load()
            });
        },
        load() {
          this.map.addSource('3DCiteLayer', {
            type: 'raster',
            tiles: [
                'https://tile.charmingglobe.com/map/dataset/'+ this.layer +'/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf',
            ],
            tileSize: 256,
            scheme: 'tms'
          });
          this.map.addLayer({
            'id': '3DCiteLayer',
            'type': 'raster',
            'source': '3DCiteLayer',
          });
          // this.map.fitBounds([JSON.parse(this.bounds).coordinates[0][0],JSON.parse(this.bounds).coordinates[0][2]],{animate:false})
          this.map.setMaxBounds([JSON.parse(this.bounds).coordinates[0][0],JSON.parse(this.bounds).coordinates[0][2]])
          this.map.setMinZoom(this.map.getZoom())
          this.rotateCamera(this.frameCount)
          this.animation = true
          this.addAnimationControl()
        },
        rotateCamera() {
          this.map.rotateTo((this.frameCount / 6) % 360, { duration: 0 })
          this.frameCount ++
          if(!this.pause){
            if(this.animationId !== -1){
              cancelAnimationFrame(this.animationId);
            }
            this.animationId = requestAnimationFrame(this.rotateCamera)
          }
        },
      addAnimationControl(){
        this.map.on('mousedown', ()=>{
          if(this.animation){
            if(this.timedOut>-1){
              clearTimeout(this.timedOut)
              this.timedOut = -1
            }
            this.pause = true
          }
        })
        this.map.on('mouseup', ()=>{
          if(this.animation){
            this.timedOut = setTimeout(()=>{
              if(this.animation) {
                this.pause = false
                this.rotateCamera(0)
              }
            },2000)
          }
        })
      },
    },

}
</script>

<style scoped lang="scss">

.display3d {
    height: 100%;
    width: 100%;
    background-color: black;
    display: flex;
    align-items: center;
    position: absolute;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

#map {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

#backBtn{
  cursor: pointer;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 40px;
  font-size: 16px;
  color: white;
  width: 110px;
  height: 60px;
  background-color: rgba(56, 56, 56, 1);
  line-height: 60px;
  text-align: center
}

</style>
